<template>
  <div>

我报名的项目

 <el-table :data="DataList" stripe style="width: 100%" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center',background:'#F5F7FA'}"
      :row-style="{background:'#ffffff'}">
  <el-table-column label="序号"  width="150px">
        <template slot-scope="scope">
          {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column prop="itemNum" label="项目编号"  width="150px">
      </el-table-column>
      <el-table-column prop="itemName" label="项目名称">
      </el-table-column>
      <el-table-column prop="biddingStartTime" label="竞价开始时间"  width="150px">
      </el-table-column>
      <el-table-column prop="biddingEndTime" label="竞价结束时间 " width="150px">
      </el-table-column>

      <el-table-column label="审核状态" width="100px">
        <template slot-scope="scope">
          <span v-if="scope.row.dataStatus==0">未审核</span>
          <span v-if="scope.row.dataStatus==1" style="color: green;">审核通过</span>
          <span v-if="scope.row.dataStatus==2" style="color: red;">未审核通过</span>
        </template>
        </el-table-column>
       <el-table-column prop="feeDate" label="保证金缴纳时间" width="150px">
        </el-table-column>
        <el-table-column prop="returnFeeDate" label="保证金退还时间" width="150px">
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="150px">
          <template slot-scope="scope">
            <el-button v-if="(scope.row.dataStatus==0&&scope.row.feeUrl==null)||scope.row.dataStatus==2" @click="showUploadFee(scope.row.id)"  type="primary" size="mini" >上传缴纳保证金凭证
            </el-button>
            <a target="_blank" :href="scope.row.feeUrl" v-if="scope.row.feeUrl!=null&&scope.row.feeUrl!=''"  style="margin-top: 5px;">
            <el-button type="success" size="mini"  style="margin-top: 10px;">查询缴纳保证金凭证
            </el-button>
              </a>

            <el-button v-if="scope.row.dataStatus==1&&scope.row.returnFeeUrl!=null" type="success" size="small" plain>查询退还保证金凭证
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="tabListPage">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>




      <el-dialog title="上传缴纳保证金凭证" :visible.sync="showUploadFeeModal" width="80%" :before-close="handleClose" append-to-body>
        <div style="width: 100%;height: 500px;">
          <el-form ref="signUp"  :inline="true" label-width="100px" style="margin-top: 10px;">
            <el-col :span="24" >
              <el-col :span="12">
                <el-form-item label="保证金凭证" label-width="150px">
                  <el-upload class="upload-demo" action="http://36.133.43.44:8547/api/web/upload"
                    :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                    :on-success="getCardPositive" multiple :limit="1" :on-exceed="handleExceed"
                    :file-list="fileListCardPositive">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-col>
            <el-button type="primary" @click="uploadFee()" icon="el-icon-check" style="margin-left: 31%;width:300px">提交
            </el-button>

          </el-form>



        </div>
      </el-dialog>

  </div>

</template>

<script>
  export default {
    data() {
      return {
        unitCode: "410800000000",
        pageNum: 1, // 默认显示第几页
        totalCount: 1, // 总条数，根据接口获取数据长度(注意：这里不能为空)
        pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
        pageSize: 10, // 默认每页显示的条数（可修改）
        DataList: [],
        countys:[],
        towns:[],
        villages:[],
        countyCode:"",
        townCode:"",
        villageCode:"",
        type:"",
        signUp:{
          id:"",
          feeUrl:"",
        },
        showUploadFeeModal:false,
        fileListCardPositive: [],



      }
    },
    created() {
      this.getData()
    },
    methods: {


      async getData() {
        var num = this.pageNum;
        // if (this.pageNum != 0) {
        //   num = this.pageNum - 1;
        // }
        const {
          data: res
        } = await this.$http.get('/web/v1/alreadySignItemList?pageNum=' + num + "&pageSize=" + this
          .pageSize );
        this.DataList = res.data.list;
        this.totalCount = res.data.total;
        console.log(res);
      },
      showUploadFee(id){
        this.signUp.id=id;
        this.showUploadFeeModal=true;
      },

      async uploadFee() {
        if(this.signUp.feeUrl==""){
          this.$message.error("请上传保证金凭证！");
          return;
        }
        const {
          data: res
        } = await this.$http.get('/web/v1/uploadFee?id=' + this.signUp.id + "&feeUrl=" + this
          .signUp.feeUrl );
          this.$message.success("保证金凭证上传成功！");
          this.getData();
          this.showUploadFeeModal=false;


      },

      // 每页显示的条数，选择每页条数的时候执行
      handleSizeChange(val) {
        this.pageSize = val // 改变每页显示的条数
        this.getData();
        this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
      },
      // 显示第几页
      handleCurrentChange(val) {
        console.log("handleCurrentChange")
        this.pageNum = val; // 改变默认的页数
        this.getData();
      },

 handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {},
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      getCardPositive(response, file, fileList) {
        console.log(response)
        this.signUp.feeUrl = response.data;
        this.$message.success("缴纳保证金凭证上传成功！");
      },
      handleClose(done) {
        done();
      },


    },


  }
</script>

<style lang="scss" scoped="">
  .select {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .selectAdd {
    width: 60%;
    height: 40px;
    border-color: #dcdfe6;
  }

  .lable {
    width: 83px;
    color: black;
    font-size: 15px;
    float: left;
    line-height: 40px;
    text-align: right;
  }

  .inp {
    width: 48%;
    height: 32px;
    border: 1px solid #ccc;

  }



  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>
